let ApplyBasicRoutes = [
  {
    // 部门资料管理
    path: '2101',
    name: '2101',
    component: () => import('@/pages/ApplyBasic/departmentManage/departmentinfo')
  }, {
  // 人员资料管理
    path: '2102',
    name: '2102',
    component: () => import('@/pages/ApplyBasic/personManage/personinfo')
  }, {
  // 人脸管理
    path: '2201',
    name: '2201',
    component: () => import('@/pages/ApplyBasic/personFaceManage/personfaceinfo')
  }, {
  // 卡务管理
    path: '2202',
    name: '2202',
    component: () => import('@/pages/ApplyBasic/cardManage/cardinfo')
  }, {
  // 身份介质流水
    path: '2203',
    name: '2203',
    component: () => import('@/pages/ApplyBasic/mediaChangeRecord/recordinfo')
  }, {
  // 二维码管理
    path: '2204',
    name: '2204',
    component: () => import('@/pages/ApplyBasic/QRCodeManage/qrcodeinfo')
  }, {
  // 人脸下载失败记录
    path: '2205',
    name: '2205',
    component: () => import('@/pages/ApplyBasic/personFaceFaildRecord/recordinfo')
  }, {
    path: '2301',
    name: '2301',
    component: () => import('@/pages/ApplyBasic/cardBasicInfoManage/cardinfo')
  }, {
  // 制卡处理
    path: '2302',
    name: '2302',
    component: () => import('@/pages/ApplyBasic/cardDealWith/dealwithcardtask')
  }, {
  // 制卡任务导出
    path: '2303',
    name: '2303',
    component: () => import('@/pages/ApplyBasic/cardTaskExport/cardtaskinfo')
  }, {
  // 制卡任务管理
    path: '2304',
    name: '2304',
    component: () => import('@/pages/ApplyBasic/cardTaskManage/cardtaskinfo')
  }, {
  // 卡激活
    path: '2305',
    name: '2305',
    component: () => import('@/pages/ApplyBasic/cardActivation/cardinfo')
  },
  {
    // 厂家管理
    path: '2401',
    name: '2401',
    component: () => import('@/pages/ApplyBasic/DeviceFactory/DeviceFactory')
  },
  {
    // 产品管理
    path: '2402',
    name: '2402',
    component: () => import('@/pages/ApplyBasic/FactoryProduct/FactoryProduct')
  },
  {
    // 设备型号
    path: '2403',
    name: '2403',
    component: () => import('@/pages/ApplyBasic/DeviceTypeInfo/DeviceTypeInfo')
  },
  {
    // 设备资料
    path: '2404',
    name: '2404',
    component: () => import('@/pages/ApplyBasic/DeviceInfo/DeviceInfo')
  },
  {
    path: '2405',
    name: '2405',
    component: () => import('@/pages/ApplyBasic/DeviceMaintenanceManage/maintenanceinfo')
  },
  {
    // 应用软件版本
    path: '2406',
    name: '2406',
    component: () => import('@/pages/ApplyBasic/AppVersion/AppVersion')
  },
  {
    // 运维流水
    path: '2407',
    name: '2407',
    component: () => import('@/pages/ApplyBasic/DeviceMaintenanceList/DeviceMaintenanceList')
  },
  {
    // 许可证
    path: '2408',
    name: '2408',
    component: () => import('@/pages/ApplyBasic/licenseManage/licenseinfo')
  },
  {
  // 商户管理
    path: '2501',
    name: '2501',
    component: () => import('@/pages/ApplyBasic/merchantManage/merchantinfo')
  },
  {
    // 设备区域管理
    path: '2502',
    name: '2502',
    component: () => import('@/pages/ApplyBasic/deviceArea/deviceArea')
  },
  {
    // 设备地点管理
    path: '2503',
    name: '2503',
    component: () => import('@/pages/ApplyBasic/deviceInstallSite/deviceInstallSite')
  },
  {
    // 设备地点管理
    path: '2504',
    name: '2504',
    component: () => import('@/pages/ApplyBasic/deviceConsumeSite/deviceConsumeSite')
  },
  {
    // 终端交易日报表
    path: '6101',
    name: '6101',
    component: () => import('@/pages/ApplyBasic/reportOfMachineDealDay/reportinfo')
  },
  {
    // 终端交易汇总
    path: '6102',
    name: '6102',
    component: () => import('@/pages/ApplyBasic/reportOfMachineDealTotal/reportinfo')
  },
  {
    // 商户清算日报表
    path: '6103',
    name: '6103',
    component: () => import('@/pages/ApplyBasic/reportOfMerchantDay/reportinfo')
  },
  {
    // 商户清算汇总
    path: '6104',
    name: '6104',
    component: () => import('@/pages/ApplyBasic/reportOfMerchantTotal/reportinfo')
  },
  {
    // 终端时段日报表
    path: '6105',
    name: '6105',
    component: () => import('@/pages/ApplyBasic/reportOfMachineWorkDay/reportinfo')
  },
  {
    // 终端时段汇总
    path: '6106',
    name: '6106',
    component: () => import('@/pages/ApplyBasic/reportOfMachineWorkTotal/reportinfo')
  },
  {
    // 商户时段汇总
    path: '6107',
    name: '6107',
    component: () => import('@/pages/ApplyBasic/reportOfMerchantWorkTotal/reportinfo')
  },
  {
    // 充值统计报表
    path: '6108',
    name: '6108',
    component: () => import('@/pages/ApplyBasic/reportOfRecharge/reportinfo')
  },
  {
    path: '6109',
    name: '6109',
    component: () => import('@/pages/ApplyBasic/reportOfAccountBalance/reportinfo')
  },
  {
    // 应收应付明细报表
    path: '6110',
    name: '6110',
    component: () => import('@/pages/ApplyBasic/reportOfReceivable/reportinfo')
  },
  {
    path: '6111',
    name: '6111',
    component: () => import('@/pages/ApplyBasic/reportOfReceivableTotal/reportinfo')
  },
  {
    path: '6112',
    name: '6112',
    component: () => import('@/pages/ApplyBasic/reportOfPersonalDiscount/reportinfo')
  },
  {
    // 个人优惠明细
    path: '6113',
    name: '6113',
    component: () => import('@/pages/ApplyBasic/reportOfPersonalDiscountTotal/reportinfo')
  },
  {
    // 个人优惠汇总
    path: '6114',
    name: '6114',
    component: () => import('@/pages/ApplyBasic/reportOfDiscountTotal/reportinfo')
  },
  {
    // 计次消费统计
    path: '6115',
    name: '6115',
    component: () => import('@/pages/ApplyBasic/reportOfCountConsume/reportinfo')
  },
  {
    // 商户订餐清算汇总报表
    path: '6118',
    name: '6118',
    component: () => import('@/pages/ApplyBasic/reportOfMerchantOrderTotal/reportinfo')
  },
  {
    // 水牌消费明细
    path: '4920',
    name: '4920',
    component: () => import('@/pages/ApplyBasic/reportOfScanCodeConsum/reportinfo')
  },
  {
    // 差错账报表
    path: '4921',
    name: '4921',
    component: () => import('@/pages/ApplyBasic/reportOfErrorAccounting/reportinfo')
  },
  {
    // 餐次窗口消费统计
    path: '4922',
    name: '4922',
    component: () => import('@/pages/ApplyBasic/reportOfMealsWindowConsum/reportinfo')
  },
  {
    // 窗口消费统计
    path: '4923',
    name: '4923',
    component: () => import('@/pages/ApplyBasic/reportOfWindowConsum/reportinfo')
  },
  {
    // 财务结算报表
    path: '4924',
    name: '4924',
    component: () => import('@/pages/ApplyBasic/reportOfFinanceSettle/reportinfo')
  },
  {
    // 系统月度对账单
    path: '4925',
    name: '4925',
    component: () => import('@/pages/ApplyBasic/reportOfMonthStatement/reportinfo')
  },
  {
    path: '4926',
    name: '4926',
    component: () => import('@/pages/ApplyBasic/reportOfRechargeDetails/reportinfo')
  },
  {
    // 水牌消费汇总
    path: '4927',
    name: '4927',
    component: () => import('@/pages/ApplyBasic/reportOfScanCodeTotal/reportinfo')
  },
  {
    // 被扫交易流水
    path: '6116',
    name: '6116',
    component: () => import('@/pages/ApplyBasic/reportOfScanDetails/reportinfo')
  },
  {
    // 被扫交易统计
    path: '6117',
    name: '6117',
    component: () => import('@/pages/ApplyBasic/reportOfScanTotal/reportinfo')
  },
  {
    // 收入明细表
    path: '6119',
    name: '6119',
    component: () => import('@/pages/ApplyBasic/reportOfIncomeDetail/reportinfo')
  },
  {
    // 人员消费汇总表
    path: '6120',
    name: '6120',
    component: () => import('@/pages/ApplyBasic/reportOfPersonConsumeTotal/reportinfo')
  },
  {
    // 部门时段消费汇总表
    path: '6121',
    name: '6121',
    component: () => import('@/pages/ApplyBasic/reportOfDeptConsumeTotal/reportinfo')
  },
  {
    // 商户时段日报表
    path: '6125',
    name: '6125',
    component: () => import('@/pages/ApplyBasic/reportOfMerchantWorkDay/reportinfo')
  },
  {
    // 消费时段日报表
    path: '6122',
    name: '6122',
    component: () => import('@/pages/ApplyBasic/reportOfConsumeDay/reportinfo')
  },
  {
    // 销户统计
    path: '6123',
    name: '6123',
    component: () => import('@/pages/ApplyBasic/reportOfCloseAccountTotal/reportinfo')
  },
  {
    // 销户结清日报表
    path: '6124',
    name: '6124',
    component: () => import('@/pages/ApplyBasic/reportOfCloseAccountDay/reportinfo')
  },
  {
    // 部门餐次汇总日报表
    path: '6127',
    name: '6127',
    component: () => import('@/pages/ApplyBasic/reportOfDeptDayConsumeTotal/reportinfo')
  },
  {
    // 水牌时段日报表
    path: '6126',
    name: '6126',
    component: () => import('@/pages/ApplyBasic/reportOfNhqrpayWorkDay/reportinfo')
  }
]

export {
  ApplyBasicRoutes
}



// WEBPACK FOOTER //
// ./src/router/ApplyBasicRoutes.js